import React from 'react';
import { Handle, Position, type NodeProps } from '@xyflow/react';
import type { ConditionNodeData } from '../TaskflowParser';

export function ConditionNode({ data }: NodeProps): React.JSX.Element {
  const d = data as ConditionNodeData;
  return (
    <div className="taskflow-condition">
      <Handle type="target" position={Position.Top} style={{ background: '#ffc107' }} />
      <div className="taskflow-condition__diamond">
        <span className="taskflow-condition__label" title={d.expression}>
          {d.expression.length > 28 ? d.expression.slice(0, 28) + '…' : d.expression}
        </span>
      </div>
      <Handle type="source" position={Position.Bottom} style={{ background: '#ffc107' }} />
    </div>
  );
}
